<template>
  <tbody v-if="business !== null">
    <tr class="m-table-admin__row">
      <td class="m-table-admin__col">
        <div class="business-list__name">
          <div class="business-list__picture" v-if="business.ImageUri">
            <img class="business-list__picture-image" :src="business.ImageUri" :alt="business.Name" />
          </div>
          <a :href="business.Url" target="_blank">{{ business.Name }}</a>
        </div>
      </td>
      <td class="m-table-admin__col">
        <span v-for="id in business.EntrepreneurIds" :key="id"> {{ getEntrepreneurName(id) }}<br /> </span>
      </td>
      <td class="m-table-admin__col">{{ getBusinessRegistrationDate(business) }}</td>
      <td class="m-table-admin__col">{{ getBusinessUserPhoneNumber(business.UserId) }}</td>
      <td class="m-table-admin__col m-table-admin__col--right">
        <a :href="`mailto:${getBusinessUserEmail(business.UserId)}`">{{ getBusinessUserEmail(business.UserId) }}</a>
      </td>
    </tr>
    <tr class="m-table-admin__row m-table-admin__row--btn">
      <td colspan="5" class="m-table-admin__col m-table-admin__col--right">
        <button class="a-btn-primary a-btn-primary--small a-btn-primary--gray a-btn-primary--ico-retract" @click="showRemoveBusinessPanel" type="button">
          {{ $t('business-list-item-remove-btn') }}
        </button>
        <div class="o-panel" v-bind:class="{ 'o-panel--open': isRemoveBusinessPanelOpen }">
          <div class="o-panel__head">
            <h2 class="o-panel__title">{{ $t('gathering-business-list-remove-title') }}</h2>
            <button type="button" class="o-panel__close" @click="hideRemoveBusinessPanel">{{ $t('panel-close') }}</button>
          </div>
          <div class="o-panel__content">
            <confirmation-popup :text="$t('gathering-business-list-remove-business-confirmation-text')" :actions="removeBusinessActions" />
          </div>
        </div>

        <div class="o-panel__overlay" @click="hideRemoveBusinessPanel"></div>
      </td>
    </tr>
  </tbody>
</template>

<script>
import i18n from '@/helpers/i18n'
import ConfirmationPopup from '@/components/popup/confirmation-popup'

export default {
  components: {
    ConfirmationPopup
  },
  props: {
    business: {
      type: Object,
      required: true
    },
    entrepreneurs: {
      type: Array,
      required: true
    },
    users: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isRemoveBusinessPanelOpen: false,
      removeBusinessActions: [
        { key: 'authorizeGathering_yes', label: this.$t('popup_confirm_label'), click: this.removeBusinessPanel },
        { key: 'authorizeGathering_no', label: this.$t('popup_dismiss_label'), click: this.hideRemoveBusinessPanel }
      ]
    }
  },
  methods: {
    getEntrepreneurName: function(id) {
      return this.entrepreneurs.find(x => x.Id === id).Name
    },
    getBusinessUserEmail: function(id) {
      return this.users.find(x => x.Id === id).Email
    },
    getBusinessUserPhoneNumber: function(id) {
      return this.users.find(x => x.Id === id).PhoneNumber
    },
    getBusinessRegistrationDate: function(business) {
      let today = new Date()
      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() + -1)
      let oneWeek = new Date()
      oneWeek.setDate(oneWeek.getDate() + -7)

      let registrationDate = new Date(business.GatheringRegistrationDate)

      if (today.getDate() === registrationDate.getDate() && today.getMonth() === registrationDate.getMonth() && today.getFullYear() === registrationDate.getFullYear()) {
        return i18n.t('gathering-registration-date-today')
      } else if (yesterday.getDate() === registrationDate.getDate() && yesterday.getMonth() === registrationDate.getMonth() && yesterday.getFullYear() === registrationDate.getFullYear()) {
        return i18n.t('gathering-registration-date-yesterday')
      } else if (oneWeek <= registrationDate) {
        let oneDay = 24 * 60 * 60 * 1000
        let days = Math.round(Math.abs((registrationDate - today) / oneDay))
        return i18n.t('gathering-registration-date-one-week').replace('{0}', days)
      }
      return `${registrationDate.getDate()} ${new Intl.DateTimeFormat('fr-CA', { month: 'long' }).format(registrationDate)} ${registrationDate.getFullYear()}`
    },
    showRemoveBusinessPanel() {
      this.isRemoveBusinessPanelOpen = true
    },
    hideRemoveBusinessPanel() {
      this.isRemoveBusinessPanelOpen = false
    },
    removeBusinessPanel() {
      this.$emit('removeBusiness')
      this.hideRemoveBusinessPanel()
    }
  }
}
</script>
